import 'css-chunk:src/index/pages/password_change/index.module.scss';export default {
  "tablet": "tablet__BdTDi",
  "sp": "sp__yqn2V",
  "pc": "pc__R23m7",
  "pcTablet": "pcTablet__x9HUq",
  "section": "section__11Vmg",
  "relative": "relative__fp2Fr",
  "row": "row__XwA5q",
  "middle": "middle__eecEo",
  "formLabel": "formLabel__uK5KE",
  "formLabel2": "formLabel2__2FRr-",
  "formLabelIssue": "formLabelIssue__QZ-IJ",
  "error": "error__kASJz",
  "space": "space__-TT53",
  "error_row": "error_row__ABfP9"
};